<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="fm03"></a><a id="page_xi">*  *  *</a></p><a id="page_xi">
<p class="blockquote1"><span class="txit">The realities of the world affected me as visions,
                and as visions only, while the wild ideas of the land of dreams became, in
                turn—not the material of my every-day existence—but in very deed that
                existence utterly and solely in itself.</span></p>
<p class="att">—Edgar Allan Poe, “Berenice”</p>
<p class="epi">Oh, lady bright! Can it be right—</p>
<p class="epi">This window open to the night?</p>
<p class="epi">The wanton airs, from the tree-top,</p>
<p class="epi">Laughingly through the lattice drop—</p>
<p class="epi">The bodiless airs, a wizard rout,</p>
<p class="epi">Flit through thy chamber in and out,</p>
<p class="epi">And wave the curtain canopy</p>
<p class="epi">So fitfully—so fearfully—</p>
<p class="epi">Above the closed and fringed lid</p>
<p class="epi">’Neath which thy slumb’ring soul lies hid,</p>
<p class="epi">That, o’er the floor and down the wall,</p>
<p class="epi">Like ghosts the shadows rise and fall!</p>
<p class="epi">Oh, lady dear, hast thou no fear?</p>
<p class="att">—Edgar Allan Poe, “The Sleeper”</p>
</a><p class="centera"><a id="page_xi">*  *  *</a><a id="page_xii"></a></p><a id="page_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?2759c537